module.exports = __webpack_public_path__ + "img/淘内免费其它（通用）示例图.858de0e2.jpeg";